import { render, staticRenderFns } from "./SignSetting.vue?vue&type=template&id=7c6c06ce&scoped=true&"
import script from "./SignSetting.vue?vue&type=script&lang=js&"
export * from "./SignSetting.vue?vue&type=script&lang=js&"
import style0 from "./SignSetting.vue?vue&type=style&index=0&id=7c6c06ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6c06ce",
  null
  
)

export default component.exports